var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-export-buttons flex flex-row flex-wrap"},[_c('a-button',{attrs:{"type":"primary","icon":"vertical-align-bottom","disabled":_vm.disabled},on:{"click":_vm.exportToCsv}},[_vm._v(" CSV ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }